import { patientCommunicationPath } from '@/lib/patientCommunication';

export function patientMessagesPath(
  patientId: string,
  messageId?: string | null,
): string {
  return patientCommunicationPath(patientId, { channel: 'messages', messageId });
}

export type MessageInboxTab = 'unread' | 'all';

export interface PatientMessageConversation {
  patient_id: string;
  patient_first_name: string;
  patient_last_name: string;
  latest_message_id: string;
  latest_content: string;
  latest_sender: 'patient' | 'clinic';
  latest_sender_name: string | null;
  latest_created_at: string;
  latest_has_attachment: boolean;
  unread_count: number;
}

export function patientDisplayName(conversation: PatientMessageConversation): string {
  return `${conversation.patient_first_name} ${conversation.patient_last_name}`.trim();
}

export function unreadConversationCount(
  conversations: readonly PatientMessageConversation[],
): number {
  return conversations.filter((item) => item.unread_count > 0).length;
}

export function filterMessageConversations(
  conversations: readonly PatientMessageConversation[],
  opts: {
    tab: MessageInboxTab;
    search: string;
    patientId: string | null;
  },
): PatientMessageConversation[] {
  const search = opts.search.trim().toLowerCase();
  return conversations.filter((item) => {
    if (opts.tab === 'unread' && item.unread_count <= 0) return false;
    if (opts.patientId && item.patient_id !== opts.patientId) return false;
    if (!search) return true;
    const haystack = [
      item.patient_first_name,
      item.patient_last_name,
      item.latest_content,
      item.latest_sender_name ?? '',
    ]
      .join(' ')
      .toLowerCase();
    return haystack.includes(search);
  });
}
